import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router';

import { formatPosition, formatRaceDetails, getProfileHelpers } from 'modules/HorseRacing/utils';

require('./HorseProfileTable.scss');

export default function HorseProfileTable({profile, earlyEntries = false}) {
  const { results: horseResults, formatDateTime, buildHref } = getProfileHelpers(profile, earlyEntries);

  if (!earlyEntries) {
    horseResults.forEach(r => r.formattedPosition = formatPosition(r));
  }

  return (
    <div>
      <table className="default-table horse-profile-results-table">
        <thead>
          <tr>
            <th>Date {earlyEntries && "/ Time"}</th>
            {!earlyEntries && <th>Pos</th>}
            <th>BHA</th>
            {!earlyEntries && <th className="horse-profile-results-table-race-type">Type</th>}
            <th>Race Details</th>
            <th>SP</th>
          </tr>
        </thead>
        <tbody>
          {horseResults.map(result => <tr key={result.race_id}>
              <td>
                <Link to={buildHref(result)}
                  className="horse-profile-racing-form-racecard-link">
                  {formatDateTime(result)}
                </Link>
              </td>
              {!earlyEntries && <td>{result.formattedPosition}</td>}
              <td>{result.bha || '-'}</td>
              {!earlyEntries && <td className="horse-profile-results-table-race-type">{result.run_type}</td>}
              <td>{formatRaceDetails(result)}</td>
              <td>{result.odds || ''}</td>
            </tr>)}
        </tbody>
      </table>
      {!horseResults.length && <p className="horse-profile-results-table-empty">No {earlyEntries ? "entries" : "results"}</p>}
    </div>
  );
}

HorseProfileTable.propTypes = {
  profile: PropTypes.object,
  earlyEntries: PropTypes.bool
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/HorseProfileTable.js